import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
	const { session, loading } = useAuth();

	if (loading) {
		return (
			<div className="flex h-screen items-center justify-center">
				<div className="text-zinc-500 dark:text-zinc-400">Loading...</div>
			</div>
		);
	}

	if (!session) {
		return <Navigate to="/login" replace />;
	}

	return <>{children}</>;
}
